import z from "zod";
import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { DataListVersionSchema } from "./useGetAllDataList";

export const getAllDataListVersionsApiKey = "getAllDataListVersions" as const;

const DataListVersionDataListSchema = z.object({
    "@id": z.string().optional(),
    id: z.number(),
    code: z.string(),
});

export const DataListVersionWithDataListSchema = DataListVersionSchema.extend({
    "@id": z.string().optional(),
    dataList: DataListVersionDataListSchema,
});

export type DataListVersionWithDataList = z.infer<typeof DataListVersionWithDataListSchema>;

type Options = {
    ids?: number[];
    enabled?: boolean;
};

export const useGetAllDataListVersions = (options?: Options) => {
    const { ids = [], enabled = true } = options || {};

    const query = useQuery({
        queryKey: [getAllDataListVersionsApiKey, ids],
        enabled: enabled,
        queryFn: async () => {
            const response = await sureApiCall.get("/api/data_list_versions", {
                params: { id: ids },
            });
            return response;
        },
        select: (response) => {
            const dataListVersions = response.data["hydra:member"];
            return zodParseWithDetailedLog(dataListVersions, DataListVersionWithDataListSchema.array(), {
                operation: "GET",
                endpoint: "/data_list_versions",
            });
        },
    });

    return {
        dataListVersions: query.data,
        ...query,
    };
};
